import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {BOOKMAKERS_REVIEW} from "../../../widgets/bookmakers-review-widget/bookmakers-review-widget.consts";

export class BettingAdRequestParams extends BaseApiRequestParams {
  usePrefix: Boolean;

  constructor(competitionId: String, publisherId: Number) {
    super();

    this.usePrefix = false;
    this.competitionIds = competitionId;
    this.publisherId = publisherId;
  }

  get competitionsParam() {
    return this.competitionIds > 0  ? `&CompetitionID=${this.competitionIds}` : '';
  }

  get publisherIdParam() {
    return this.publisherId ? `&publisher=${this.publisherId}` : '';
  }

  get fullUrl(): String {
    const appType: String = `appType=${this.initialParams.appTypeId}`;
    const userCountryId: String = `cid=${this.initialParams.userCountryId}`;
    const lang: String = `lang=${this.initialParams.langId}`;
    const fullUrl: String = `${BOOKMAKERS_REVIEW.BETTING_AD_PREFIX}${appType}&${userCountryId}&${lang}${this.competitionsParam}${this.publisherIdParam}`.ensureHttps();

    return fullUrl;
  }
}
